<template>
  <RouterLink :to="to" class="item">
    <FeatherIcon
      v-if="!hasRegistered"
      icon="alert-circle"
      size="16"
      class="mr-2 text-red"
    />
    <FeatherIcon
      v-else-if="isUnderExamination || isModified"
      icon="circle"
      size="16"
      class="mr-2 text-yellow"
    />
    <FeatherIcon
      v-else-if="isRejected && !isVerified"
      icon="alert-circle"
      size="16"
      class="mr-2 text-red"
    />
    <FeatherIcon icon="check-circle" v-else size="16" class="mr-2 text-green" />
    <span class="text-primary-dark">
      {{ title }}
    </span>
    <!-- NOTE: 並び順で表示を制御しているため注意 -->
    <span
      class="d-flex align-items-center ml-auto text-size-14 text-yellow"
      v-if="isModified"
    >
      <FeatherIcon icon="alert-circle" size="14" class="mr-1" />
      入力済み
    </span>
    <span
      class="d-flex align-items-center ml-auto text-size-14 text-red"
      v-else-if="!hasRegistered"
    >
      <FeatherIcon icon="alert-circle" size="14" class="mr-1" />
      未入力
    </span>
    <span
      class="d-flex align-items-center ml-auto text-size-14 text-yellow"
      v-else-if="isUnderExamination"
    >
      <FeatherIcon icon="circle" size="14" class="mr-1" />
      審査中
    </span>
    <span
      v-else-if="isVerified"
      class="d-flex align-items-center ml-auto text-size-14 text-green"
    >
      <FeatherIcon icon="check-circle" size="14" class="mr-1" />
      認証済み
    </span>
    <span
      v-else-if="isRejected && !isModified"
      class="d-flex align-items-center ml-auto text-size-14 text-red"
    >
      <FeatherIcon icon="alert-circle" size="14" class="mr-1" />
      差戻し
    </span>
    <span
      v-else
      class="d-flex align-items-center ml-auto text-size-14 text-green"
    >
      <FeatherIcon icon="check-circle" size="14" class="mr-1" />
      入力済み
    </span>
  </RouterLink>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { RouteLocationRaw } from "vue-router";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

@Component({
  components: {
    FeatherIcon
  }
})
export default class RegistrationInformationCard extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  to!: RouteLocationRaw;

  @Prop({
    type: String,
    required: true
  })
  title!: string;

  @Prop({
    type: Boolean,
    required: true
  })
  isUnderExamination!: boolean;

  @Prop({
    type: Boolean,
    required: true
  })
  isVerified!: boolean;

  @Prop({
    type: Boolean,
    required: true
  })
  isRejected!: boolean;

  @Prop({
    type: Boolean,
    required: true
  })
  hasRegistered!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  isModified!: boolean;
}
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  align-items: center;
  padding: 16px;
  background-color: $white;
  border: 1px solid $gray-04;
  border-radius: 4px;
}
</style>
